import { Field } from "@progress/kendo-react-form";
import { FormRegion } from "../../../../components/formregion";
import { useDispatch, useSelector } from "react-redux";
import {
  FormDropDownList,
  FormDropDownListById,
  FormInput,
  FormTextArea,
} from "../../../../forms/form-components";
import { useTranslation } from "react-i18next";
import { getWidgetKeyFromType } from "../../../../components/widgets/utils";

const ReviewStep = (props) => {
  //#region state
  const pageState = useSelector((state) => state.createSchedulePage);
  const currentTheme = useSelector((state) => state.currentTheme);
  const { t } = useTranslation();

  const lstOfReports = pageState.formValues.Reports;

  const simplifiedWidgets = [
    {
      Id: 0,
      WidgetTypeId: 0,
      Title: t("schedule.select"),
    },
    ...(pageState.formValues.Widgets ?? []).map((widget) => ({
      Id: widget.Id,
      WidgetTypeId: widget.WidgetTypeId,
      Title: `${getWidgetKeyFromType(widget.WidgetTypeId) ?? t("extras.widget")} - ${
        widget.Settings?.Title?.trim() || t("schedule.notitle")
      }`,
    })),
  ];

  const ddlType = [
    { Id: 0, Title: t("schedule.select") },
    //{ Id: 1, Title: "Pdf" },
    { Id: 2, Title: t("schedule.excel") },
  ];

  const ddlSource = [
    { Id: 0, Title: t("schedule.select") },
    { Id: 1, Title: t("schedule.google_sheets") },
    // { Id: 2, Title: "Https" },
    // { Id: 3, Title: "SFTP" },
    // { Id: 4, Title: "Email" },
  ];
  const ddlRecurrsEvery = [
    { Id: 0, Title: t("slices.none") },
    { Id: 5, Title: t("slices.fiveMins") },
    { Id: 10, Title: t("slices.tenMins") },
    { Id: 15, Title: t("slices.fiveteenMins") },
    { Id: 30, Title: t("slices.thirtyMins") },
    { Id: 60, Title: t("slices.oneHour") },
    { Id: 120, Title: t("slices.twoHours") },
    { Id: 180, Title: t("slices.threeHours") },
    { Id: 240, Title: t("slices.fourHours") },
    { Id: 300, Title: t("slices.fiveHours") },
    { Id: 360, Title: t("slices.sixHours") },
    { Id: 720, Title: t("slices.twelveHours") },
    { Id: 1440, Title: t("slices.oneDay") },
    { Id: 2880, Title: t("slices.twoDays") },
    { Id: 4320, Title: t("slices.threeDays") },
    { Id: 10080, Title: t("slices.sevenDays") },
    { Id: 43200, Title: t("slices.thirtyDays") },
  ];

  //#endregion

  return (
    <FormRegion>
      {/* <div className="error-list" id="error-list">
        {pageState.error_lst.map((e) => (
          <div key={e.Code}>
            <span style={{ color: `${currentTheme.error}` }}>{e.Code}: </span>
            {e.Message}
          </div>
        ))}
      </div> */}

      <Field
        id={"rptId"}
        name={"rptId"}
        label={t("reporting.design.report")}
        component={FormDropDownListById}
        dataItemKey="Id"
        textField="Title"
        data={lstOfReports}
        disabled
      />
      <Field
        id={"widgetId"}
        name={"widgetId"}
        label={t("extras.widget")}
        component={FormDropDownListById}
        dataItemKey="Id"
        textField="Title"
        data={simplifiedWidgets}
        disabled
      />
      <div className="dataset-info">
        <Field
          id={"Name"}
          name={"Name"}
          label={t("schedule.name")}
          component={FormInput}
          disabled
        />
        <Field
          id={"Description"}
          name={"Description"}
          label={t("schedule.description")}
          component={FormTextArea}
          disabled
        />

        <Field
          id={"Type"}
          name={"Type"}
          label={t("schedule.type")}
          component={FormDropDownListById}
          data={ddlType}
          dataItemKey="Id"
          textField="Title"
          value={pageState.formValues.Type}
          disabled
        />

        <Field
          id={"Source"}
          name={"Source"}
          label={t("schedule.source")}
          component={FormDropDownListById}
          data={ddlSource}
          dataItemKey="Id"
          textField="Title"
          value={pageState.formValues.Source}
          disabled
        />
        {pageState.formValues.ShowGoogleSheets && (
          <Field
            id={"File"}
            name={"File"}
            label={t("schedule.file")}
            component={FormDropDownListById}
            data={pageState.formValues.GoogleList}
            dataItemKey="SheetId"
            textField="FilePath"
            value={pageState.formValues.File}
            disabled
          />
        )}

        {pageState.formValues.File && (
          <Field
            id="SheetName"
            name="SheetName"
            label={t("schedule.sheetname")}
            component={FormDropDownList}
            data={
              pageState.formValues.GoogleList?.find(
                (e) => e.SheetId === pageState.formValues.File,
              )?.SheetNames || []
            }
            value={pageState.formValues.SheetName}
            disabled
          />
        )}

        {pageState.formValues.GoogleSheetId > 0 &&
          pageState.formValues.CustomField && (
            <>
              <Field
                id={"CustomField"}
                name={"CustomField"}
                label={t("schedule.customField")}
                component={FormInput}
                disabled
              />
              <Field
                id={"CustomFieldValue"}
                name={"CustomFieldValue"}
                label={t("schedule.customFieldValue")}
                component={FormInput}
                disabled
              />
            </>
          )}

        {pageState.formValues.RecurrencyFrom == "fromRecurrency" && (
          <Field
            id={"RecurrsEvery"}
            name={"RecurrsEvery"}
            label={t("alerts.recurs")}
            component={FormDropDownListById}
            data={ddlRecurrsEvery}
            dataItemKey="Id"
            textField="Title"
            disabled
          />
        )}
        {pageState.formValues.RecurrencyFrom == "fromCron" && (
          <Field
            id={"CronValue"}
            name={"CronValue"}
            label={t("schedule.CronValue")}
            disabled
            component={FormInput}
            style={{ marginBottom: "20px" }}
          />
        )}

        {pageState.formValues.GoogleSheetId > 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              width: "100%",
            }}
          >
            {pageState.formValues.CustomFields.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  gap: 12,
                  width: "100%",
                  alignItems: "flex-end",
                }}
              >
                <div style={{ width: 30, fontWeight: 600 }}>{item.index}.</div>

                <div className="k-form-field">
                  <label className="k-label k-text-disabled">
                    {t("schedule.customField")}
                  </label>
                  <div className="k-form-field-wrap">
                    <input
                      disabled={true}
                      className="k-input k-input-md k-rounded-md k-input-solid"
                      value={item.field}
                    />
                  </div>
                </div>

                <div className="k-form-field">
                  <label className="k-label k-text-disabled">
                    {t("schedule.customFieldValue")}
                  </label>
                  <div className="k-form-field-wrap">
                    <input
                      disabled={true}
                      className="k-input k-input-md k-rounded-md k-input-solid"
                      value={item.value}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <style>
        {`
            .create-schedule-page .form-region-container{
                margin-bottom:30px;
            }
            .create-schedule-page .form-region-container .form-region-root .header{
                margin-bottom:10px;
            }

            .create-schedule-page .form-region-container .dataset-grid{
                width : 100%;
                overflow-x:auto;
            }
            .create-schedule-page-form .k-form-field textarea#DatasetDescriptionNoEdit{
                height:50px !important;
            }

            .create-schedule-page .checkbox-list{
            display:flex;
            justify-content:space-between;
          }
              .create-schedule-page > .content .form-root  .k-form  .checkbox-list .k-form-field:nth-child(1){
                margin-top:32px;
          }
          .create-schedule-page .error-list{
              padding-bottom:20px;
              border-bottom:1px solid ${currentTheme.componentBorderColor};
              margin-bottom:15px;
          }
          
        `}
      </style>
    </FormRegion>
  );
};

export default ReviewStep;
